import pl from "@locales/navigation/pl.json";
import en from "@locales/navigation/en.json";

export default {
  pl: pl,
  en: en,
};
